import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";

import LogoSVS from "../../assets/images/logo_SVS_short.svg";

const useStyles = makeStyles((theme) => ({
    centered: {
        width: 400,
        height: 280,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        background: "transparent",
        filter: "blur(0px)",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        "& > span": {
            display: "block",
            width: "100%",
            textAlign: "center",
        },
    },
    logo: {
        width: "100%",
    },
    preloaderImage: {
        opacity: 1,
        display: "block",
    },
    text: {
        display: "block",
        textAlign: "center",
        width: "100%",
        fontSize: "1.25rem",
    },
}));

const PagePreloader = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.centered}>
            {/* <img src="./images/InterwindPreloader200.gif" className={classes.preloaderImage} alt="Ładowanie..." /> */}
            <span>
                <img src={LogoSVS} className={classes.logo} alt="SVS logo" />
            </span>
            <img src="/images/DualBallPreloader200.gif" className={classes.preloaderImage} alt="Ładowanie..." />
            <div className={classes.text}>{t("Ładowanie...")}</div>
        </div>
    );
};

export default PagePreloader;
